/** Bỏ dấu tiếng Việt + chữ thường để tìm kiếm không phân biệt dấu ("Nguyễn" ~ "nguyen"). */
export const fold = (s: string | null | undefined) =>
  String(s ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .trim();

/** So sánh tên theo tiếng Việt. */
export const byViName = (a: string, b: string) => a.localeCompare(b, 'vi');
